export default __webpack_public_path__ + "static/media/brave_zone_s2.35ab4138.png";